<template>
    <div>
        <div class="cogi-tab">
            <ul class="menu flex">
                <li v-for="tab in tabs" :class="{ 'is-active': tab.props.selected }" @click="tabClicked(tab)" :key="tab.props">
                    <a href="#">
                        <div class="cogi-tab-title">
                            {{ i18n.t(tab.props.title) }}
                        </div>
                        <div class="cogi-tab-subtitle">{{ i18n.t(tab.props.subtitle) }}</div>
                    </a>
                </li>
            </ul>
        </div>
        <div class="tab-details">
            <slot></slot>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { ref } from 'vue'
    import type CogiTab from './CogiTab.vue'
    import { useI18n } from 'vue-i18n'
    const i18n = useI18n()

    interface IPropsTabs {
        validerSurOnglet: boolean
    }

    const props = withDefaults(defineProps<IPropsTabs>(), { validerSurOnglet: false })

    const tabs = ref(<Array<typeof CogiTab>>[])

    //TODO.. CORRIGER... LA REACTIVITE DU COMPUTED NE FONCTIONNE PAS BIEN ICI...
    //LE CURRENTTAB N'EST PAS BON
    function getCurrentTab(): typeof CogiTab {
        const selectedTab = tabs.value.filter(tab => tab.props.selected)

        if (selectedTab[0]) return selectedTab[0]

        return tabs.value[0]
    }

    const emit = defineEmits<{
        tabClicked: [number, number]
        tabSelected: [typeof CogiTab]
    }>()

    function tabClicked(tab: typeof CogiTab) {
        if (props.validerSurOnglet) {
            const currentTab = getCurrentTab()
            const currentTabIndex = tabs.value.indexOf(currentTab)
            const futureTabIndex = tabs.value.indexOf(tab)
            emit('tabClicked', currentTabIndex, futureTabIndex)
        } else {
            selectTab(tab)
        }
    }

    function selectTab(selectedTab: typeof CogiTab) {
        tabs.value.forEach(tab => {
            const isActive = tab.props.title === selectedTab.props.title
            tab.isActive = isActive
            tab.props.selected = isActive
        })
        //emit('tabSelected', selectedTab)
    }

    defineExpose({ tabs, selectTab, getCurrentTab })
</script>
